<template>
  <div class="meetingmanualvotes-container">
    <div class="meetingmanualvotes-Top">
      <h3 v-if="meeting" class="white--text">
        {{ meeting.organizationName }} - {{ meeting.name }}
      </h3>
    </div>
    <div class="meetingmanualvotes-Left"></div>
    <div class="meetingmanualvotes-Right"></div>
    <div class="meetingmanualvotes-Bottom"></div>
    <div class="meetingmanualvotes-Content">
      <v-card elevation="4" style="height: 100%;">
        <v-card-text>
          <v-list>
            <v-list-item-group color="primary">
              <v-list-item
                v-for="member in electors"
                :key="member.id"
                :to="{
                  name: 'manualMemberVote',
                  params: { meetingId: meetingId, electorSsn: member.id }
                }"
              >
                <v-list-item-content>
                  <v-list-item-title v-html="member.name"></v-list-item-title>
                  <v-list-item-subtitle
                    v-html="member.id"
                  ></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon>
                    <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      subscription: null
    };
  },
  computed: {
    meetingId() {
      return this.$route.params.meetingId;
    },
    electors() {
      const els = this.$store.getters["meetings/getElectors"];
      return els.filter(e => e.manuallyRegistered);
    },
    meeting() {
      return this.$store.getters["meetings/getMeeting"](
        this.$route.params.meetingId
      );
    }
  },
  watch: {},
  methods: {},
  async mounted() {
    await this.$store.dispatch(
      "meetings/decisionListener",
      this.$route.params.meetingId
    );
    await this.$store.dispatch(
      "meetings/electorsListener",
      this.$route.params.meetingId
    );
    const auth = this.$store.getters["auth/auth"];

    await this.$store.dispatch("meetings/manualVotesListener", {
      meetingId: this.$route.params.meetingId,
      userId: auth.uid
    });
  }
};
</script>

<style>
/* .meetingmanualvotes-container { */
/*   height: 100vh; */
/*   margin-left: 100px; */
/*   margin-top: 100px; */
/*   margin-bottom: 100px; */
/*   margin-right: 100px; */
/*   overflow-y: scroll; */
/* } */

.meetingmanualvotes-container {
  height: 100vh;
  display: grid;
  grid-template-columns: 53px 1fr 53px;
  grid-template-rows: 53px 1fr 53px;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "Left Top Right"
    "Left Content Right"
    "Left Bottom Right";
}

.meetingmanualvotes-Left {
  grid-area: Left;
}
.meetingmanualvotes-Top {
  grid-area: Top;
  height: 100%;
  line-height: 53px;
}
.meetingmanualvotes-Right {
  grid-area: Right;
}
.meetingmanualvotes-Content {
  grid-area: Content;
}
.meetingmanualvotes-Bottom {
  grid-area: Bottom;
}
</style>
